import { createTheme } from "@mui/material/styles";
const theme = createTheme({

    palette: {
        primary: {
            main: "#d25333",
        },
        // secondary: {
        //     main: "#20639B",
        // }
    },
});
export default theme;
